<h1>Cambio de Clave</h1>
<div class="tab-slider--container">
	<form #changePasswordForm="ngForm">
		<div class="usuario_contrasena">
			<div class="form_row clearfix">
				<div class="form_cell">
					<label>Nro de Socio:</label>
					<span class="user_dni_codigo">
						<input
							type="text"
							disabled
							numeric
							[(ngModel)]="password.partnerNumber"
							name="partnerNumber"
							[ngClass]="{ val_error: validatePartnerNumber() }"
							class="form_element"
							placeholder="Ingrese número de Socio"
							maxlenght="3"
							maxlenght="7"
							required
						/>
					</span>
					<app-valid-message-form
						*ngIf="validatePartnerNumber()"
						[message]="messageErrorCode"
						type="error"
					></app-valid-message-form>
				</div>
			</div>
			<div class="form_row clearfix">
				<div class="form_cell">
					<label>Nueva Clave:</label>
					<span class="user_contrasena">
						<input
							type="password"
							[(ngModel)]="password.password"
							[ngClass]="{ val_error: validatePassword() }"
							name="password"
							class="form_element"
							placeholder="Ingrese su nueva clave"
							minlength="8"
							maxlength="10"
							required
							alphaSpecialPassword
						/>
					</span>
					<app-valid-message-form
						*ngIf="validatePassword()"
						[message]="messageErrorPassword"
						type="error"
					></app-valid-message-form>
					<span
						>Clave debe contener: Una letra, un número y uno de estos caracteres especiales (& &#35; &#46; , ;).
						Longitud entre 8 a 10 caracteres.</span
					>
				</div>
			</div>
			<div class="form_row clearfix">
				<div class="form_cell">
					<label>Confirmar Nueva Clave:</label>
					<span class="user_contrasena">
						<input
							type="password"
							[(ngModel)]="password.repeatPassword"
							[ngClass]="{ val_error: validateRepeatPassword() }"
							name="repeatPassword"
							class="form_element"
							placeholder="Reingrese su nueva clave"
							minlength="8"
							maxlength="10"
							required
							alphaSpecialPassword
						/>
					</span>
					<app-valid-message-form
						*ngIf="validateRepeatPassword()"
						[message]="messageErrorRepeatPassword"
						type="error"
					></app-valid-message-form>
					<span>Debe coincidir con nueva clave</span>
				</div>
				<app-valid-message-form
					*ngIf="messageError !== ''"
					[message]="messageError"
					type="error"
				></app-valid-message-form>
				<div class="center_content">
					<button
						class="boton_ingresar enviar_clave"
						[disabled]="changePasswordForm.invalid && validateEqualPassword()"
						(click)="clickSave()"
					>
						Guardar
					</button>
				</div>
			</div>
		</div>
	</form>
</div>
